import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {IziviaI18nMessage} from '../../domain/iziviaI18nMessage/iziviaI18nMessage';

@Injectable({
    providedIn: 'root'
})
export class FrontIziviaTranslateService {

    constructor(private readonly translateService: TranslateService) {
    }

    public translate(labelKey: string, interpolateParams?: object): string {
        const label = !!labelKey ? this.translateService.instant(labelKey, interpolateParams) : labelKey;

        if (label === labelKey) {
            console.warn(`No label value found for key '${labelKey}' and language '${this.translateService.currentLang}'`);
        }

        return label;
    }

    public translateI18nMessage(i18nMessage: IziviaI18nMessage): string {
        const params = {};

        if (!i18nMessage) {
            console.warn(`Attempted to translate null or undefined I18nMessage`);
            return null;
        }

        if (i18nMessage.params) {
            Object.keys(i18nMessage.params).forEach(
                key => params[key] = i18nMessage.params[key].value
            );
        }

        return this.translate(i18nMessage.key, params);
    }

    public translateOrNull(labelKey: string, interpolateParams?: object): string {
        const label = !!labelKey ? this.translateService.instant(labelKey, interpolateParams) : labelKey;

        if (label === labelKey) {
            return null;
        }

        return label;
    }

    public translateWithDefault(labelKey: string, defaultLabelKey: string, interpolateParams?: object): string {
        let label = this.translateService.instant(labelKey, interpolateParams);
        if (label === labelKey) {
            label = this.translate(defaultLabelKey, interpolateParams);
        }
        return label;
    }
}
